import React, { useState } from "react";
import axios from "axios";
import validator from "validator";
import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material/styles";
import { TextField, Button } from "@mui/material";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

export default function Settings() {
  const [addEmail, setAddEmail] = useState("");
  const [addMspId, setAddMspId] = useState("");
  const [removeMspId, setRemoveMspId] = useState("");
  const [removeEmail, setRemoveEmail] = useState("");

  const theme = createTheme({
    palette: {
      primary: {
        main: "#ec644c",
      },
    },
  });

  const handleAddChange = (e) => {
    setAddEmail(e.target.value);
  };
  const handleAddMspid = (e) => {
    setAddMspId(e.target.value);
  };
  const handleRemoveMspid = (e) => {
    setRemoveMspId(e.target.value);
  };
  const handleRemoveChange = (e) => {
    setRemoveEmail(e.target.value);
  };

  const handleAddPrincipal = () => {
    console.log("clck");
    axios({
      method: "post",
      url: process.env.REACT_APP_ADD_PRINCIPALS_URL,
      headers: {
        "X-Api-Key": process.env.REACT_APP_X_API_KEY,
        "Access-Control-Allow-Origin": "*",
      },
      data: {
        commonName: addEmail,
        mspID: addMspId,
      },
    }).then((res) => {
      window.location.reload();
    });
  };

  const handleRemovePrincipal = () => {
    axios({
      method: "delete",
      url: process.env.REACT_APP_REMOVE_PRINCIPALS_URL,
      headers: {
        "X-Api-Key": process.env.REACT_APP_X_API_KEY,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
      },
      data: {
        commonName: removeEmail,
        mspID: removeMspId,
      },
    }).then((res) => {
      console.log(res);
      window.location.reload();
    });
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Navbar />
        <Sidebar />
        {/* <div className="header-container">
          <h3 style={{ fontSize: 25 }}>Principal Management</h3>
        </div>

        <div className="description-container">
          <p className="description-paragraph">
            As one of the FlexCoin Principals you can add or remove other
            principals. This can be done equally by any other FlexCoin Principal
            and in the same manner.
          </p>
  </div> */}

        <div className=" h-10 bg-white mx-24 text-gray-500 flex rounded justify-start pl-2 align-middle mt-4">
          <h1 style={{ fontSize: 25 }}>Principal Management</h1>
        </div>

        <div className="h-12 bg-white mx-24 flex text-gray-500 rounded justify-start pl-2 align-middle mt-4">
          <p className="description-paragraph">
            As one of the Communitas Principals you can add or remove other
            principals. This can be done equally by any other Communitas
            Principal and in the same manner.
          </p>
        </div>

        <div className="settings-container">
          <div className="table-container">
            <h3 className="font-bold text-3xl text-gray-500 pl-2 my-4">
              Add a Principal
            </h3>{" "}
            <hr className="container-hr" />
            <h3 style={{ fontStyle: "italic", fontSize: 16, color: "gray" }}>
              To add a new Communitas Principal enter her e-mail and MSP ID.
            </h3>
            <div className="settings-actions">
              <TextField
                placeholder="E-mail"
                id="outlined-basic"
                variant="outlined"
                onChange={handleAddChange}
              />
              <TextField
                placeholder="MSP ID"
                id="outlined-basic"
                variant="outlined"
                onChange={handleAddMspid}
              />
              {validator.isEmail(addEmail) && addMspId !== "" ? (
                <button
                  className="w-80 h-12 ml-[25%] text-white bg-[#bbabab] rounded hover:bg-green-600"
                  onClick={() => handleAddPrincipal()}
                >
                  Add
                </button>
              ) : (
                <button
                  disabled={true}
                  className="w-80 h-12 ml-[25%] text-white bg-[#bbabab] rounded hover:bg-gray-600"
                >
                  Add
                </button>
              )}
            </div>
          </div>
          <div className="table-container">
            <h3 className="font-bold text-3xl text-gray-500 pl-2 my-4">
              Remove a Principal
            </h3>{" "}
            <hr className="container-hr" />
            <h3 style={{ fontStyle: "italic", fontSize: 16, color: "gray" }}>
              To remove a Communitas Principal enter her e-mail and MSP ID.
            </h3>
            <div className="settings-actions">
              <TextField
                placeholder="E-mail"
                id="outlined-basic"
                variant="outlined"
                onChange={handleRemoveChange}
              />
              <TextField
                placeholder="MSP ID"
                id="outlined-basic"
                variant="outlined"
                onChange={handleRemoveMspid}
              />
              {validator.isEmail(removeEmail) && removeMspId !== "" ? (
                <button
                  onClick={() => handleRemovePrincipal()}
                  className="w-80 h-12 ml-[25%] text-white bg-[#bbabab] rounded hover:bg-red-600"
                >
                  Remove
                </button>
              ) : (
                <button
                  disabled
                  className="w-80 h-12 ml-[25%] text-white  bg-[#bbabab] rounded hover:bg-gray-600"
                >
                  Remove
                </button>
              )}
            </div>
          </div>
        </div>
      </ThemeProvider>
    </div>
  );
}
